import type { PropsWithChildren } from "react";
import { Slot } from "radix-ui";

import { tw } from "@/shared/utils";

export const SvgSlot = ({
  className,
  ...props
}: PropsWithChildren & Slot.SlotProps) => {
  return (
    <Slot.Root
      className={tw("size-full shrink-0", className)}
      aria-hidden="true"
      {...props}
    />
  );
};
